/* eslint-disable @typescript-eslint/no-explicit-any */
import { walletConnectProvider } from '@web3modal/ethereum';
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react';
import { configureChains } from 'wagmi';
import { polygon } from 'wagmi/chains';

const { chains } = configureChains(
  [polygon],
  [walletConnectProvider({ projectId: 'b602800e0a4465c2192ee8f48909d7be' })],
);

const projectId = process.env.NEXT_PUBLIC_PROJECT_ID || 'b602800e0a4465c2192ee8f48909d7be';

const metadata = {
  name: 'DMTP',
  description: 'Messages to wallet addresses',
  url: 'https://dmtp.tech',
  icons: ['https://avatars.githubusercontent.com/u/37784886'],
};

export const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata });
createWeb3Modal({
  wagmiConfig,
  projectId,
  chains,
  themeMode: 'light',
});
